import { render, staticRenderFns } from "./VacationsNeedMeetingDayLegend.vue?vue&type=template&id=2f0b81ce&"
import script from "./VacationsNeedMeetingDayLegend.vue?vue&type=script&lang=js&"
export * from "./VacationsNeedMeetingDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f0b81ce')) {
      api.createRecord('2f0b81ce', component.options)
    } else {
      api.reload('2f0b81ce', component.options)
    }
    module.hot.accept("./VacationsNeedMeetingDayLegend.vue?vue&type=template&id=2f0b81ce&", function () {
      api.rerender('2f0b81ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/day-legend/VacationsNeedMeetingDayLegend.vue"
export default component.exports